"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { createClient } from "@/lib/supabase/client";

export function AuthCtaLink({
  href = "/dashboard",
  className,
  children,
  ...props
}: React.ComponentProps<typeof Link>) {
  const hrefStr = typeof href === "string" ? href : (href.pathname ?? "/dashboard");
  const [resolvedHref, setResolvedHref] = useState(
    `/auth?next=${encodeURIComponent(hrefStr)}`
  );

  useEffect(() => {
    const supabase = createClient();
    supabase.auth.getSession().then(({ data }) => {
      setResolvedHref(
        data.session ? hrefStr : `/auth?next=${encodeURIComponent(hrefStr)}`
      );
    });
  }, [hrefStr]);

  return (
    <Link href={resolvedHref} className={className} {...props}>
      {children}
    </Link>
  );
}
